module.exports = __webpack_public_path__ + "img/157.6847f241.jpg";